const MessageStore={
    state:()=>({
        messages:[]
    }),
    mutations:{
        addMessage(state, item){
            const newMessage = { ...item, messageId: uuidv4() };
            state.messages=[newMessage, ...state.messages];
        },

        removeMessage(state, item){
            state.messages=[...state.messages.filter(e => e.messageId !== item.messageId)];
        },
    },
    actions:{
        addMessage(context,data){
            context.commit('addMessage', data)
        },

        removeMessage({commit}, data){
            commit('removeMessage', data)
        },
    }
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

export {MessageStore};